import myzod, { Infer } from 'myzod'

export const addInterestSchema = myzod.object({ focus: myzod.string() })

export const removeInterestSchema = myzod
  .object({ id: myzod.string() })
  .or(myzod.object({ ids: myzod.array(myzod.string()) }))

export const InterestIdSchema = myzod.string().pattern(/^Interest#/)
export const interestSchema = myzod.object({
  id: InterestIdSchema,
  focus: myzod.string(),
})

export const interestActionRequestSchema = myzod.object({
  action: myzod.literal('interest'),
  method: myzod.literals('list', 'add', 'remove'),
  body: addInterestSchema.optional().or(removeInterestSchema).optional(),
})

export const listInterestsBodyResponseSchema = myzod.object({
  action: myzod.literal('interest'),
  method: myzod.literals('list'),
  interests: myzod.array(interestSchema),
})

export const interestAddedBodyResponseSchema = myzod.object({
  action: myzod.literal('interest'),
  method: myzod.literals('added'),
  interest: interestSchema,
})

export const interestBodyResponses = interestAddedBodyResponseSchema.or(
  listInterestsBodyResponseSchema,
)

export type InterestActionRequest = Infer<typeof interestActionRequestSchema>
export type Interest = Infer<typeof interestSchema>
export type InterestBodyResponses = Infer<typeof interestBodyResponses>
export type InterestListResponse = Infer<typeof listInterestsBodyResponseSchema>
export type InterestAddedResponse = Infer<
  typeof interestAddedBodyResponseSchema
>
